import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Spinner from "./Spinner";
import { wait } from '../libs/wait';
import { TextInput } from './Form';

@observer
class SelectInput extends React.Component {

  @observable openOptions = false;
  @observable filterText = '';
  @observable readyToClose = false;
  @observable focusedElement = -1;
  @observable scrollTop = 0;
  @observable closing = false;
  @observable viewOffset = 0;

  componentDidMount() {
    this.focusedElement = -1;
    window.addEventListener('mousedown', this.windowMouseDownListener);
    window.addEventListener('mouseup', this.windowMouseUpListener);

    let modalElement = document.getElementsByClassName('modalChildren');
    if (!!modalElement && !!modalElement.length) {
      modalElement[modalElement.length - 1].addEventListener('scroll', this.scrollListener);
      this.scrollTop = modalElement[modalElement.length - 1].scrollTop;
    }
  }

  componentWillUnmount() {
    this.focusedElement = -1;
    window.removeEventListener('mousedown', this.windowMouseDownListener);
    window.removeEventListener('mouseup', this.windowMouseUpListener);

    let modalElement = document.getElementsByClassName('modalChildren')[0];
    if (!!modalElement && !!modalElement.length) modalElement[modalElement.length - 1].removeEventListener('scroll', this.scrollListener);
  }

  windowMouseDownListener = e => {
    let { id, label } = this.props;
    const element = document.getElementById(id || label)

    if (!!element && !element.contains(e.target) && this.openOptions) {
      this.readyToClose = true;
    }
  };

  windowMouseUpListener = () => {
    if (this.readyToClose) {
      this.toggleOptionOpen();
      this.readyToClose = false;
    }
  };

  scrollListener = (e) => {
    this.scrollTop = e.target.scrollTop;
  }

  // windowClickListener = e => {
  //   let {label} = this.props;
  //   if (!document.getElementById(label).contains(e.target)) this.openOptions = false;
  // };

  onChangeFilterText = e => {
    this.focusedElement = -1;
    this.filterText = e.target.value;
    this.filterText = e.target.value;
  };

  onInputKeyDown = e => {
    const { id, label } = this.props;

    let options = document.querySelectorAll(`.${(id || label).replace(/\s/g, '')}-option`);
    if (+e.keyCode === 40 && this.focusedElement + 1 < options.length) {
      e.preventDefault();
      this.focusedElement = this.focusedElement + 1;
      options[this.focusedElement].focus();
    } else if (+e.keyCode === 38 && this.focusedElement - 1 > -1) {
      e.preventDefault();
      this.focusedElement = this.focusedElement - 1;
      options[this.focusedElement].focus();
    } else if (+e.keyCode === 13 && this.focusedElement >= -1 && this.focusedElement < options.length) {
      // this.onOptionClicked(options[this.focusedElement].value);
      this.onOptionClicked(options[this.focusedElement].getAttribute("value"));
    }
  };

  toggleOptionOpen = async () => {
    if (this.openOptions) {
      this.closing = true;
      await wait(80)
      this.closing = false;
    }
    this.openOptions = !this.openOptions;
    this.filterText = ''
    if (this.openOptions) {
      this.viewOffset = 0;
      setTimeout(() => {
        let optionsElement = document.getElementById('multi-select-options');
        if (!!optionsElement) {
          const viewOffset = optionsElement.getBoundingClientRect().bottom - window.innerHeight;
          this.viewOffset = viewOffset > 0 ? viewOffset + 10 : 0;
        }
      }, 80);
    }
  };

  getFilteredOptions = options => {
    if (this.filterText === '') return options;
    const { filterOptions, fields } = this.props;
    if (!filterOptions) return options.filter(item => item[fields.label].toString().toLowerCase().indexOf(this.filterText.toString().toLowerCase()) === 0);
    return filterOptions(options, this.filterText.toString().toLowerCase())
  };

  onOptionClicked = (value) => {
    const { onChange } = this.props;
    onChange({ target: { value } });
    this.toggleOptionOpen()
  };

  _renderOptions = (options, onCreateItem) => {
    const { id, label, value, isLoading, fields, defaultValue } = this.props;
    return (<div id='multi-select-options' className={`multi-select-options ${this.closing ? 'multi-select-options-closing' : ''}`} style={{ transform: `translateY(${4 - this.scrollTop - (!!this.viewOffset ? this.viewOffset : 0)}px)` }}>
      <div className='options-controller'>
        <input type='text' onFocus={() => this.focusedElement = -1} placeholder={`Search ${(id || label)}`} onChange={this.onChangeFilterText} onKeyDown={this.onInputKeyDown} style={{ minWidth: '250px' }} autoFocus />
      </div>
      {isLoading && !options.length ? <Spinner /> :
        <ul id={`${(id || label)}-select-options`}>
          {!defaultValue && <li tabIndex={-1} onKeyDown={this.onInputKeyDown} className={`${(id || label).replace(/\s/g, '')}-option`} key={`${(id || label)}-option-null`} value={''} onClick={e => this.onOptionClicked('')} style={{ background: value === '' ? '#efefef' : '' }}>--</li>}
          {options.map((item, i) => {
            return (
              <li tabIndex={i} onKeyDown={this.onInputKeyDown} className={`${(id || label).replace(/\s/g, '')}-option`} key={`${(id || label)}-option-${item[fields.value]}`} value={item[fields.value]} onClick={e => this.onOptionClicked(item[fields.value])} style={{ background: value === item[fields.value] ? '#efefef' : '' }} data-toggle='tooltip' title={item[fields.value]}>
                {item[fields.label]}
              </li>
            )
          })}
        </ul>}
      {onCreateItem && <div className='multi-select-item-create' onClick={() => {
        onCreateItem();
        this.toggleOptionOpen()
      }}>Create New Item</div>}
    </div>);
  };

  render() {
    const { id, displayLabel, label, options, fields, sortBy, sortOptions, small, onCreateItem, readOnly } = this.props;
    let value = !!this.props.value || +this.props.value === 0 ? this.props.value : this.props.defaultValue;
    let selectedOption = (!!value || +value === 0) && (options || []).find(item => item[fields.value] == value);
    const sortKey = sortBy || fields.label;

    if (readOnly) {
      const option = (options || []).find(item => item[fields.value] == value);
      return <TextInput label={label} value={!!option ? option[fields.label] : ''} readOnly />;
    }

    return (
      <div className='formInput flex flex-row'>
        {label !== '' && <label className='flex flex-column justify-center'>{displayLabel || label}</label>}
        <div id={id || label.replace('*', '')} className='formInputMulti'>
          <div className={`${small ? 'multi-select-input-small' : 'multi-select-input'}`} onClick={this.toggleOptionOpen}>
            <div>{(!!value || +value === 0) && selectedOption ? selectedOption[fields.label] : '--'}</div>
            <i className='fa fa-caret-down' />
          </div>
          {this.openOptions &&
            this._renderOptions(
              this.getFilteredOptions(options)
                .sort(sortOptions || ((a, b) => !!a[sortKey] && b[sortKey] && a[sortKey].toString().toLowerCase().trim() > b[sortKey].toString().toLowerCase().trim() ? 1 : -1)),
              onCreateItem
            )}
        </div>
      </div>
    );
  }
}

export const FormSelectInput = SelectInput;


// WEBPACK FOOTER //
// ./src/components/SelectInput.js